
import SubscriptionForm from "@/components/common/subscription/SubscriptionForm.vue";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { ICoupon } from "@/i/coupon";
import VueScrollTo from "vue-scrollto";
import { mapGetters } from "vuex";
import api from "@/api/index.ts";

@Component({
  name: "Header",
  components: {
    SubscriptionForm
  },
  computed: {
    ...mapGetters("app", ["isFontLoad", "isLangDetected", "lang"])
  }
})
export default class CouponCard extends Vue {
  isHeaderScroll: boolean = false;
  isFontLoad: boolean;
  isLangDetected: false;
  menuIsOpen: boolean = false;
  numberOfArticles = 1;
  currentLang: string = "";

  @Prop({ default: null })
  coupon: ICoupon;

  categories: any[];

  async mounted() {
    const articleCategories = await api.getArticleCategories();
    if (articleCategories) {
      const reqData = articleCategories.data;
      this.categories = reqData.categories;
      this.numberOfArticles = reqData.numberOfArticles;
    }
    this.detectCurrentActiveRoute();
    this.handleScroll();
  }

  checkCurrentLang() {
    this.currentLang = localStorage.getItem("currentLang");
  }

  async created() {
    this.checkCurrentLang();
  }

  handleScroll() {
    window.addEventListener("scroll", () => {
      this.isHeaderScroll = window.pageYOffset > 0;
    });
  }

  detectCurrentActiveRoute() {
    const currentRoute = this.$route.name;
    // this.linkArr = this.linkArr.map((item: IHeaderLink) => {
    //   if (item.name === currentRoute) {
    //     return Object.assign({}, item, { active: true });
    //   }
    //   return item;
    // });
  }

  @Watch("$route")
  onRouteChange() {
    this.detectCurrentActiveRoute();
  }

  @Watch("lang")
  async onLangChanged() {
    this.checkCurrentLang();
    await this.fetchData();
    setTimeout(() => {
      this.$forceUpdate();
    }, 500);
  }

  async fetchData() {
    this.categories = [];
    this.numberOfArticles = 1;
    const req = await api.getArticleCategories();
    this.categories = req.data.categories;
    this.numberOfArticles = req.data.numberOfArticles;
  }

  handleClickLogo() {
    if (this.$router.currentRoute.name === "home") {
      VueScrollTo.scrollTo("body");
    } else {
      this.$router.push({ name: "home" });
    }
  }

  handleClickMenu() {
    this.menuIsOpen = !this.menuIsOpen;
  }

  @Watch("$route")
  onPropertyChanged(value: string, oldValue: string) {
    if (this.menuIsOpen) {
      this.menuIsOpen = false;
    }
  }
}
